import { createEntityStore } from "@datorama/akita";
import { writable } from 'svelte/store';



const initialStat = {
    data:{}
}

export const store = writable(createEntityStore(initialStat, {
    name:"data"
}));

export const connector = createEntityStore(initialStat, {
    name:"data"
});